import api from '../api';
import { windowResize } from '../utils';

export const dispatchBalance = (balance) => ({
	type: 'BALANCE',
	payload: balance
});

export const getBalance = () => dispatch => {
	return api.getBalance().then((response) => {
		const balance = response['data'];
		dispatch(dispatchBalance(balance));
		windowResize();
	});
}



// WEBPACK FOOTER //
// ./actions/balanceActions.js